import React from 'react'
import PropTypes from 'prop-types'
import TopBar from '../bars/top-bar'
import BackIconButton from '../buttons/BackIconButton'
import ImgCover from '../utilities/img-cover'
import MoreInfoBlock from '../texts/more-info-block'
import NormalText from '../texts/normal-text'
import HeadingBeta from '../headings/heading-beta'
import HeadingDelta from '../headings/heading-delta'
import Indicator from '../texts/indicator'
import InfoExpanders from '../lists/info-expanders'
import InfoExpandersItem from '../lists/info-expanders-item'
import InfoBlock from '../texts/info-block'
import InfoText from '../texts/info-text'
import LinkAnchor from '../links/link-anchor'
import SocialButtons from '../social/social-buttons'
import MapBox from '../../ui/maps/map-box'
import { charityShape } from '../../services/prop-types'

const createTopBarLeftChildren = () => {
  const topBarLeftChildren = [<BackIconButton key='BackIconButton' />]
  return topBarLeftChildren
}

const CharityDetail = props => {
  const {
    charity,
    hasSocialMedia,
    socialMedia,
    ourEventsLink,
    ourItemsLink,
    contactLink,
    // translations
    locationText,
    viewMapText,
    contactWithUsText,
    ourMisionText,
    ourEventsText,
    ourItemsText,
    contactText
  } = props

  return (
    <div>
      <TopBar theme='light-bar' leftChildren={createTopBarLeftChildren()} />
      <div className='detail-item'>
        {charity.photo && (
          <div className='detail-image'>
            <ImgCover src={charity.photo} alt={'charity'} />
          </div>
        )}
        <div className='detail-info'>
          <div className='detail-section desk-half'>
            <HeadingBeta>{charity.name}</HeadingBeta>
            <NormalText light>{charity.shortDescription}</NormalText>
            <Indicator
              className='shy-indicator'
              labelText={locationText}
              titleText={charity.location}
            >
              <LinkAnchor
                iconName='map-pin'
                text={viewMapText}
                linkTo='#map-box'
              />
            </Indicator>
            {hasSocialMedia && (
              <Indicator
                className='shy-indicator'
                labelText={contactWithUsText}
              >
                <SocialButtons socialMedia={socialMedia} />
              </Indicator>
            )}
          </div>
          <div className='detail-section'>
            <InfoBlock>
              <HeadingDelta>{ourMisionText}</HeadingDelta>
              <MoreInfoBlock limitLines={5} text={charity.description} />
            </InfoBlock>
          </div>
          <InfoExpanders>
            {ourEventsLink && (
              <InfoExpandersItem
                href={ourEventsLink}
                iconName='fundrising-events-2'
              >
                {ourEventsText}
              </InfoExpandersItem>
            )}
            {ourItemsLink && (
              <InfoExpandersItem
                href={ourItemsLink}
                iconName='auction-products'
              >
                {ourItemsText}
              </InfoExpandersItem>
            )}
            {contactLink && (
              <InfoExpandersItem href={contactLink} iconName='question'>
                {contactText}
              </InfoExpandersItem>
            )}
          </InfoExpanders>
          <div className='detail-section'>
            <InfoBlock>
              <HeadingDelta>{locationText}</HeadingDelta>
              <InfoText iconName='map-pin'>
                <p>{charity.location}</p>
              </InfoText>
            </InfoBlock>
            {charity.lat &&
              charity.lng && (
                <MapBox
                  lat={charity.lat}
                  lng={charity.lng}
                  containerElement={<div className='map-box' id='map-box' />}
                  mapElement={<div style={{ height: '100%' }} />}
                />
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

CharityDetail.propTypes = {
  charity: charityShape.isRequired,
  hasSocialMedia: PropTypes.bool.isRequired,
  socialMedia: PropTypes.shape({
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.strin,
    google: PropTypes.string
  }),
  ourEventsLink: PropTypes.string,
  ourItemsLink: PropTypes.string,
  contactLink: PropTypes.string,
  // translations
  locationText: PropTypes.string.isRequired,
  viewMapText: PropTypes.string.isRequired,
  contactWithUsText: PropTypes.string.isRequired,
  ourMisionText: PropTypes.string.isRequired,
  ourEventsText: PropTypes.string.isRequired,
  ourItemsText: PropTypes.string.isRequired,
  contactText: PropTypes.string.isRequired
}

export default CharityDetail



// WEBPACK FOOTER //
// ./src/ui/views/charity-detail.js